import { Button, Grid } from "@material-ui/core";
import React from "react";
import Footer from "./Footer";
import Header from "./Header";
import TableRow from "./TableRow";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";

const {
  PDFViewer,
  Document,
  Page,
  StyleSheet,
} = require("@react-pdf/renderer");

const styles = StyleSheet.create({
  closeInvoice: {
    backgroundColor: "red",
    alignItems: "flex-end",
    margin: "5px",
    color: "white",
  },
  page: {
    postion: "relative",
    padding: 30,
    flexDirection: "column",
    fontSize: "12px",
  },
  section: {
    margin: 10,
    padding: 10,
    flexGrow: 1,
  },
  pdfViewer: {
    width: "100%",
    height: "100vh",
    textAlign: "center",
  },
  closeReport: {
    display: "flex",
    justifyContent: "flex-end",
  },
});
const BuReportLayout = (props) => {
  const history = useHistory();
  console.log("propssss", props);

  const handleBack = () => {
    history.push("/view-patients-bu");
  };
  const splitInto2D = (data, objectsPerArray) => {
    const numArrays = Math.ceil(data?.length / objectsPerArray);
    const result = [];

    for (let i = 0; i < numArrays; i++) {
      const startIdx = i * objectsPerArray;
      const endIdx = Math.min((i + 1) * objectsPerArray, data.length);
      result.push(data.slice(startIdx, endIdx));
    }

    return result;
  };
  let filteredData = props.selectedViewPatientBuList.filter((el, i) => {
    return el.showPatientInConsolidatedReport === true;
  });
  console.log("filteredData", filteredData);
  let data = splitInto2D(filteredData, 3);
  console.log("2d generated data in bu", data);

  return (
    <>
      <Grid style={styles.closeReport} container>
        <Button
          style={styles.closeInvoice}
          variant="contained"
          color="default"
          onClick={handleBack}
        >
          Close Report
        </Button>
      </Grid>

      <PDFViewer style={styles.pdfViewer}>
        <Document title={"Report"}>
          {data?.map((row, index) => {
            return (
              <Page size="A4" style={styles.page} key={index}>
                <Header orgzName={props.userStore?.userProfile?.orgz_name} orzLogoUrl={props.userStore?.userProfile?.orzLogoUrl} />
                <TableRow items={row} />
                <Footer totalPage={data.length} currentPage={index + 1} />
              </Page>
            );
          })}
        </Document>
      </PDFViewer>
    </>
  );
};
function mapStateToProps(store) {
  return {
    userStore: store.userStore,
    selectedViewPatientBuList:
      store.viewPatientBuStore.selectedViewPatientBuList,
  };
}
export default connect(mapStateToProps, {})(BuReportLayout);
